import YTableAir from './src'

YTableAir.install = function(Vue) {
  Vue.component(YTableAir.name, YTableAir)
}

export default YTableAir
